import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProductionOrderService, ProductionOrderFilter, ProductionOrderId } from '../../services/production-order.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';

import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { ProductVntaService } from '../../services/product-vnta.service';
import { Utils } from '../../util';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { CustomerBillService, CustomerBillId } from '../../services/customer-bill.service';
import { PurchaseOrderId, PurchaseOrderService } from '../../services/purchase-order.service';
import { PurchaseRequestService, PurchaseRequestId } from '../../services/purchase-request.service';

@Component({
    selector: 'app-read-production-order',
    templateUrl: './read-production-order.component.html',
    styleUrls: ['./read-production-order.component.css', '../../app.component.css']
})

export class ReadProductionOrderComponent implements OnInit, OnDestroy {
    allowed: boolean = false;
    permission: any = {};
    loading: boolean[] = [false];
    get loaded(): boolean { return !this.loading.includes(false); }

    productionOrders: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Folio', name: 'name', sort: 'desc' },
        { title: 'Cliente', name: 'customerName' },
        { title: 'Estatus', name: 'status' },
        { title: 'Entrega en', name: 'deliveryDate' },
        { title: 'Cantidad', name: 'quantity' },
        { title: 'Clave Prod', name: 'prCode' },
        { title: 'Descripción', name: 'shortDescription' },
        { title: 'Cancelado', className: 'center', name: 'canceled_icon'},
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
          { name: 'clear', title: '', styleIcon: 'clear', action: 'onCancel', styleClass: 'btn-floating btn waves-effect red lighten-1' },
          { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
          { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 5;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
          onCancel: this.openModalCancel.bind(this),
          onEdit: this.onEdit.bind(this),
          onDelete: this.onDelete.bind(this)
        }
    };

    subs: any[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: ProductionOrderService,
        private customerService: CustomerSupplierService,
        private prVntaService: ProductVntaService,
        private fiscalDataService: FiscalDataService,
		    private permissionService: PermissionService,
        private authService: AuthService,
        private settingsService: CatalogsSettingsService,
        private afh: FirestoreService,
        private billService: CustomerBillService,
        private odcService: PurchaseOrderService,
        private rdcService: PurchaseRequestService,
        private router: Router
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        let setSub = settingsService.getPayrollSettings('1').subscribe(({tableQuantity}) => {
          setSub.unsubscribe();
          this.itemsPerPage = tableQuantity;
          console.log(this.itemsPerPage);
          /* if(!localStorage.re_odp__filter) this.loadProductionOrders(15);
          else{
            let filter = JSON.parse(localStorage.re_odp__filter);
            if(!filter.dateIndex) this.loadProductionOrders(15);
            else{
              this.receivedAll = true;
              this.loadProductionOrders();
            }
          } */
          this.receivedAll = true;
          this.loadProductionOrders();
        });

    }

    ngOnInit() {

    }
    ngOnDestroy(){
      this.subs.map((_,index) => {
        this.subs[index].unsubscribe();
      });
    }

    loadProductionOrders(days=undefined) {
        this.loading[0] = false;
        if(this.subs[0]) this.subs[0].unsubscribe();
        this.subs[0] = this.service.getProductionOrders({filterDays: days, onEmpty: ()=>{this.loading[0]=true;}}).subscribe(tempOrders => {
            console.log(`loaded ${tempOrders.length} odps, days: ${days}`);
            let customersSub = this.customerService.getCustomers({onEmpty: ()=>{
              this.loading[0] = true;
              toast('Advertencia: No hay clientes.', 3000);
            } }).subscribe(customers => {
                let cs = window['odpCustomers'] || [];
                if(cs.length > customers.length) customers = cs;
                else window['odpCustomers'] = JSON.parse(JSON.stringify(customers));
                    
                //CUSTOMER DATA
                this.readObjs = [];
                this.readObjs[0] = {};
                this.rowsRead[0] = customers.map(customer => {
                    customer.id = customer.id$;
                    this.readObjs[0][customer.id] = {...customer};
                    return customer;
                });
                //console.log(this.rowsRead[0], customers);
                //CUSTOMER DATA

                //PRODUCTION ORDER DATA
                this.productionOrders = [];

                for (const idx in tempOrders) {
                  //console.log(`qwertyyyyyyyyyyyyyyyyyyy ${idx}: '${tempOrders[idx].customer.id}'`, this.readObjs[0])
                  tempOrders[idx].customerName = (this.readObjs[0][tempOrders[idx].customer.id] || {}).name || '';
                  tempOrders[idx].prCode = tempOrders[idx].prClient && tempOrders[idx].prClient.code || 'N.A.';

                  tempOrders[idx].canceled_icon = tempOrders[idx].canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;
                  
                  this.productionOrders.push(tempOrders[idx]);
                }
                this.verifyCancelable();

                //this.filterBar = new ProductionOrderFilter(this.productionOrders, days ? {} : JSON.parse(this.filterBar.json));
                this.filterBar = new ProductionOrderFilter(this.productionOrders, JSON.parse(localStorage.re_odp__filter || '{}'));
                this.applyFilterBar();
                //PRODUCTION ORDER DATA

                this.loading[0] = true;
            });
            this.subs[1] = customersSub;
        });
    }

    onCellClick(data: any): any {
        this.service.returnFromViewTo = 'default';
        this.router.navigate(['/vw_production_order/' + data.row.id$]);
    }

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.continueReadTo(0);
    }

    onEdit(data: any) {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        this.router.navigate(['/edt_production_order/' + data.row.id$ + '/' + data.row.customer.id]);
    }

    onDelete(data: any) {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.deleteProductionOrder(data.row.id$);
    }

    onExcel(){
      let {itemsPerPage: items, page} = this;
      this.itemsPerPage = this.data.length;
      this.page = 1;
      this.onChangeTable(this.config);
      let rows = [
        ['Folio', 'Cliente', 'Estatus', 'Entrega en', 'Cantidad', 'Clave Prod', 'Descripción'],
        ...this.rows.map(({name:n,customerName:cn,status:s,deliveryDate:dd,quantity:q,prCode:p,shortDescription:sd}) => ({n,cn,s,dd,q,p,sd})),
      ]
      Utils.downloadExcel(rows, `ODP_${Utils.today.replace(/-/g, '')}`);
      this.itemsPerPage = items;
      this.page = page;
      this.onChangeTable(this.config);
    }

    reasonMsg: string = '';
    cancelingOdp: ProductionOrderId = null;
    async continueCancel(){
      if(!this.reasonMsg) return toast('Ingrese una justificación.', 2000);
      try{
        let data: Partial<ProductionOrderId> = {
          canceled: true,
          status: 'key99',
          cancelReasons: [
            ...(this.cancelingOdp.cancelReasons || []),
            {datetime: `${Utils.today}, ${Utils.time}`, msg: this.reasonMsg},
          ],
        };
        await this.service.putProductionOrder(data, this.cancelingOdp.id);
        this.reasonMsg = '';
        this.closeModalCancel();
        toast('Éxito', 2000);
      }catch(error){
        toast('Error inesperado.', 2000);
      }
    }
    bills: CustomerBillId[];
    odcs: PurchaseOrderId[];
    rdcs: PurchaseRequestId[];
    async verifyCancelable(){
      if(!this.bills) this.bills = await this.afh.colWithIds<CustomerBillId>(this.billService.collection);
      if(!this.odcs) this.odcs = await this.afh.colWithIds<PurchaseOrderId>(this.odcService.collection);
      if(!this.rdcs) this.rdcs = await this.afh.colWithIds<PurchaseRequestId>(this.rdcService.collection);
      for(let odp of <ProductionOrderId[]>this.productionOrders){
        let reasons: string[] = [];
        //let odpRef = this.afh.doc(`${this.service.collection}/${odp.id}`).ref;

        //Verify clear of remissions
        if(odp.remittedQuantity) reasons.push('Ya se ha remitido cantidad de esta orden.');
        //Verify clear of customerBills
        let hasBills = this.bills.some(bill => {
          if(odp.id == 'LAbNcrIFFzOhD2yRDEcI') console.log(11, bill.productionOrderRef.id == odp.id);
          if(!bill.active) return false;
          if(bill.productionOrderRef.id == odp.id) return true;
          return false;
        });
        if(odp.id == 'LAbNcrIFFzOhD2yRDEcI') console.log(12, hasBills);
        if(hasBills) reasons.push('Hay facturas que incluyen esta orden de producción.');
        //Verify clear of odcs
        let hasOdcs = this.odcs.some(odc => {
          if(!odc.active || odc.canceled) return false;
          for(let pr of odc.prForOrders) if(pr.odpId == odp.id || pr.odpName == odp.name) return true;
          return false;
        });
        if(odp.id == 'LAbNcrIFFzOhD2yRDEcI') console.log(13, hasOdcs);
        if(hasOdcs) reasons.push('Hay órdenes de compra asociadas a esta orden de producción.');
        //Verify clear of rdcs
        let hasRdcs = this.rdcs.some(rdc => {
          if(odp.id == 'LAbNcrIFFzOhD2yRDEcI') console.log(14, rdc.productionOrderRef.id == odp.id);
          if(!rdc.active || rdc.canceled) return false;
          if(rdc.productionOrderRef.id == odp.id) return true;
          return false;
        });
        if(odp.id == 'LAbNcrIFFzOhD2yRDEcI') console.log(15, hasRdcs);
        if(hasRdcs) reasons.push('Hay requisiciones de compra asociadas a esta orden de producción.');

        odp['cancelable'] = !reasons.length;
        odp['cancelableReasons'] = reasons;
      }
    }
    modalActionsCancel = new EventEmitter<string|MaterializeAction>();
    modalParamsCancel = [{dismissible: true}];
    openModalCancel({row: bill}: {row: ProductionOrderId}) {
      this.cancelingOdp = bill;
      this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
    }
    closeModalCancel() {
      this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
    }

    deleteProductionOrder(id$) {
        this.service.delProductionOrder(id$).then(res => {
            this.loadProductionOrders(this.receivedAll ? undefined : 15);
        });
    }

    ////////////////////////////////////////////////////////////////////FilterBar
    receivedAll: boolean = false;
    filterBar: ProductionOrderFilter = new ProductionOrderFilter([], {} /* JSON.parse(localStorage.re_odp__filter || '{}') */);
    applyFilterBar(){
      localStorage.re_odp__filter = this.filterBar.json;
  
      this.data = this.filterBar.filteredData;
      this.length = this.data.length;
      this.onChangeTable(this.config);
    }
    onChangeDateFilterBar(){
      //this.filterBar.customerIndex = 0;
      localStorage.re_odp__filter = this.filterBar.json;
      if(this.filterBar.dateIndex && !this.receivedAll){
        this.loadProductionOrders();
        this.receivedAll = true;
      }else{
        this.applyFilterBar();
      }
    }
    ////////////////////////////////////////////////////////////////////FilterBar



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      this.closeModalRead();
      this.service.windowReplace('add', `${this.selectedIds[0]}`);
    }else{
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  readPlaceholders = [ 'un cliente' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[]];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
